import React from "react";
import AppBaseComponent from "../../../components/AppBaseComponent";
import { connect } from "react-redux";
import Ax from "../../../components/hoc/Ax";
import TapApiUrls, { INVENTORY_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import HttpAPICall from "../../../services/HttpAPICall";
import { Helmet } from "react-helmet";
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import TapIcon from "../../../services/TapIcon";
import { Link } from "react-router-dom";
import Loader from "../../../components/ui/Loader/Loader";
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from "../../../components/TapUi";
import DownloadFile from "../../../services/DownloadFile";
import { Collapse } from 'bootstrap';
import TapSelect from "../../../components/ui/TapSelect";
import moment from "moment";
import CurrencyFormatter from "../../../services/CurrencyFormatter";

class StockMovementWarehouseReport extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.reportFilterFormInitialState   =   {
            search_warehouse_ids                :   [],
            date_range                          :   'current_quarter',
            date_range_start                    :   '',
            date_range_end                      :   '',
        };

        this.reportFilterFormLabel          =   {
            search_warehouse_ids                :   'Warehouse : ',
            date_range                          :   'Date Range : ',
        };

        this.state          =   {
            listing_loading             :   false,
            reportDownloading           :   false,
            listingMeta                 :   null,
            listingData                 :   [],
            allWarehouses               :   [],
            allPeriods                  :   [],
            reportFilterForm            :   {...this.reportFilterFormInitialState},
            submittedReportFilterForm   :   {...this.reportFilterFormInitialState},
            download_access             :   false,     
            reportData                  :   null,
            showTbl                     :   false,     
            criteriaHeight                      :    0 

        }
        this.criteriaRef = React.createRef();
        this.stockMovementUrl = `${INVENTORY_API_BASE_URL_2}/report/stock-movement-warehouse-wise`;

    }
    updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };
    componentDidMount() {
        setTimeout(() => {
            this.updateCriteriaHeight();
        }, 1000);
        if (this.props.all_warehouses.length  > 0 || this.props.all_periods.length > 0) {
            this.initializeData(this.props)
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
             setTimeout(() => {
            this.updateCriteriaHeight();
        }, 1000);
        }
    }
    initializeData          (pr)  {
        
        const report_name   =   pr?.location?.pathname ? pr.location.pathname.split('/')[2] : '';
        const reportData    =   pr?.report_listing.length > 0 ? pr.report_listing.filter(d => d.key === report_name) : [];
        
        let date_range      =   'current_quarter';
        let ParamObject     =   new URLSearchParams(this.props.location.search);
        if(ParamObject.get('date_range')) {
            date_range      =   ParamObject.get('date_range');
        }
        this.setState({
            reportData                  :   reportData.length > 0 ? reportData[0] : null,
            download_access             :   reportData.length > 0  && reportData[0].download_access === 'Y' ? true  : false,
            allWarehouses       :   pr.all_warehouses.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` }}),
            allPeriods          :   pr.all_periods,
            reportFilterForm    :   {...this.state.reportFilterForm, date_range: date_range},
        }, () =>{
            // setTimeout(() => {
            this.reportFilterhandler();
            //this.reportFilterFormSubmit();
            // }, 1000);
           
        });
    }    

    loadListData            =       (page = 1)  =>  {
        this.setState({
            showTbl                     :   true,
            listing_loading             :   true,
            listingData                 :   [],
            listingMeta                 :   null,
            reportDownloading           :   false
        });
        let params                      =   {page:page, ...this.state.submittedReportFilterForm, action:"data"};
        HttpAPICall.withAthorization('GET', this.stockMovementUrl, this.props.access_token, params, {}, (res) => {
            let respData                =   res.data;
            this.setState({
                listingData                 :   respData.data,
                // reportDownloadBtn           :   true,
                listingMeta                 :   {
                    from                        :   respData.from,
                    to                          :   respData.to,
                    total                       :   respData.total,
                    last_page                   :   respData.last_page,
                    per_page                    :   respData.per_page,
                    current_page                :   respData.current_page
                }
            });
        }, (err) => {}).then(() => {
            this.setState({listing_loading: false});
        });
    }

    closeReport         =   ()  =>  {
        this.setState({showTbl : false});
        this.props.history.push('/report')
        //this.props.history.goBack()
    }

    reportDownload          =   ()  =>  {
        this.setState({
            reportDownloading   :   true
        });
        HttpAPICall.withAthorization('GET', this.stockMovementUrl, this.props.access_token, {action : 'download', ...this.state.submittedReportFilterForm} , {} , (response) => 
            DownloadFile.file(null,response.data.msg,response.data.navigation,this.props)
        ).then(() => this.setState({reportDownloading: false}));
    }

    stockMovementWarehouseList          =  ()  =>   {
        
        return (
          <Ax>
            <table className="table table-bordered  align-middle bg-white mt-2">
              <thead className="align-middle table-secondary"
              style={{
                    top: `${this.state.criteriaHeight}px`,
                    position: 'sticky',
                }}>
                <tr>
                  <th className="text-center" style={{ width: "25%" }}>Warehouse Name</th>
                  <th className="text-center" style={{ width: "15%" }}>Warehouse Code</th>
                  <th className="text-center" style={{ width: "10%" }}>Opening</th>
                  <th className="text-center" style={{ width: "10%" }}>Received</th>
                  <th className="text-center" style={{ width: "10%" }}>Issued</th>
                  <th className="text-center" style={{ width: "10%" }}>Balance</th>
                  <th className="text-center" style={{ width: "10%" }}>Total Amount</th>
                  <th className="text-center" style={{ width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {this.state.listing_loading ? (
                  <tr>
                    <td className="text-center" colSpan="8">
                      <Loader />
                    </td>
                  </tr>
                ) : this.state.listingData.length > 0 ? (
                  this.state.listingData.map((wm, key) => {
                    return (
                      <tr key={key}>
                        <td>{wm.name}</td>
                        <td>{wm.code}</td>
                        <td className="text-end">{wm.opening_qty}</td>
                        <td className="text-end">{wm.receive_qty}</td>
                        <td className="text-end">{wm.issue_qty}</td>
                        <td className="text-end">{wm.balance_qty}</td>
                        <td className="text-end">
                        <CurrencyFormatter currencyCode={this.props.default_currency} amount={wm.balance_amount}/></td>
                        <td className="text-center">
                            <Link to={
                              {pathname: `/report/stock_movement_item_wise`, state:{warehouses_id: [wm.id], date_range: this.state.submittedReportFilterForm.date_range}
                              }}
                            >
                                View Detail
                            </Link>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td className="text-center" colSpan="8"></td>
                  </tr>
                )}
              </tbody>
            </table>
          </Ax>
        );
    };

    reportFilterhandler         =   (collapse = true)  =>  {
        collapse && new Collapse(document.getElementById('reportFilterForm'));
        if(document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }

    reportFilterFormSubmit                  =   (event=null)  =>  {
        event && event.preventDefault();
        event && this.reportFilterhandler(true);
        
        let serachFormKeys                  =   Object.keys(this.state.reportFilterForm);
        let searchedElems                   =   [];
        let itemSearchParams                =   {};
        serachFormKeys.map((key)        =>  {
            let label                       =   this.reportFilterFormLabel[key];
            let value                       =   this.state.reportFilterForm[key];
            if(value && value.toString().length > 0) {
                itemSearchParams[key]      =   value;
                if(label) {
                    let show_val            =   value;
                    if(key == 'search_warehouse_ids') {
                        show_val            =   this.state.allWarehouses.filter((s) => value.includes(s.value)).map(s => s.label);
                    }
                    if(key == 'date_range') {
                        let  start_range        =      moment(this.state.reportFilterForm.date_range_start).format('DD-MMM-YYYY');
                        let end_range           =      moment(this.state.reportFilterForm.date_range_end).format('DD-MMM-YYYY');
                        let display_custom      =      `Custom Date Range (${start_range} - ${end_range})`;
                        show_val                =     this.state.allPeriods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        this.setState({
            submittedReportFilterForm           :   {...this.state.reportFilterForm},
            formSearchedElems                   :   searchedElems
        }, () => {
            this.loadListData(1);
        });
    }

    reportFilterFormJsx = () => {
        return (<div id="reportFilterForm" className="bg-white collapse " >
            <form onSubmit={this.reportFilterFormSubmit} className={['p-3', 'filter_form'].join(' ')}>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end">Warehouse</label>
                    <div className="col-sm-6">
                        <TapSelect
                            options={this.state.allWarehouses}
                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'reportFilterForm', 'search_warehouse_ids')}
                            value={this.state.allWarehouses.filter(u => this.state.reportFilterForm?.search_warehouse_ids?.includes(u.value))}
                            isSearchable={true}
                            isMulti={true}
                            isClearable={true}
                            placeholder="Select Warehouses"
                        />
                    </div>
                </div>

                <div className="row my-3">
                    <label className="col-sm-3 col-form-label text-end">Select Period</label>
                    <div className="col-sm-6">
                        <PeriodSelectionWithCustom
                            menuPlacement="bottom"
                            periods={this.state.allPeriods ? this.state.allPeriods : []}
                            value={this.state.reportFilterForm.date_range}
                            startDate={this.state.reportFilterForm.date_range_start}
                            endDate={this.state.reportFilterForm.date_range_end}
                            onSelectPeriod={(period, startDate, endDate) => {
                                this.setState({
                                    reportFilterForm
                                        : {
                                        ...this.state.reportFilterForm,
                                        date_range: period,
                                        date_range_start: startDate ? startDate : null,
                                        date_range_end: endDate ? endDate : null
                                    }
                                });
                            }}
                            required={true}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={this.state.listing_loading ? true : false} className="btn btn-primary px-4">Show Report</button>
                    </div>
                    <hr />
                </div>
            </form>
        </div>);
    }

    pageTitleBar            =   ()  =>  {
        return (<div className="page_title row m0">
            <div className="col-sm-12">
                <h3><TapIcon.FontAwesomeIcon icon={TapIcon.faCubes} /> {this.state.reportData?.name}</h3>
                <div className="text-end mt15">
                    <button type="button"  className="btn btn-secondary" onClick={this.reportFilterhandler}>Change Filter</button>
                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                        <TapIcon.imageIcon icon={TapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                        {this.state.reportDownloading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2"/>) : null}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li><Link className={['dropdown-item', !this.state.download_access ? 'disabled' : ''].join(' ')} onClick={this.reportDownload}>Download</Link></li>
                    </ul>
                    <button type="button" className="btn btn-secondary" onClick={this.closeReport}>
                        <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                    </button>
                </div>
            </div>
        </div>);
    }
   
    render          =   ()  =>  {
        return (
          <ApplicationLayout>
            <Helmet>
              <title>Stock Movement Warehouse Wise - Report</title>
            </Helmet>
            {this.pageTitleBar()}
              <div className="container-fluid pl5">
                <div className="page_containt row">
                  <div id="pageTbl" className="pageTbl col-12 pb-2">
                    {
                        this.reportFilterFormJsx()
                    }
                    {
                        this.state.showTbl &&
                        <>
                                    <div ref={this.criteriaRef}
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                        }}>
                                        <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} />
                                    </div>
                            {this.stockMovementWarehouseList()}
                            {
                                this.state.listingMeta
                                ?
                                <DisplayListPagination  meta={this.state.listingMeta} onPageChange={(e) => this.loadListData(e.selected + 1)}/>
                                : null
                            }
                        </>
                    }
                  </div>
                </div>
              </div>
          </ApplicationLayout>
        );
    }

}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        isc_configuration       :   state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
        default_currency        :   state.app && state.app.default_currency ? state.app.default_currency : 'INR',
        all_periods             :   state.app && state.app.periods ? [...state.app.periods , {key : 'custom' , display : 'Custom Date Range'}] : [],
        report_listing          :   state.app && state.app.report_listing && state.app.report_listing.length > 0 ? state.app.report_listing : []
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(StockMovementWarehouseReport);